"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENROLLMENT = [
    {
        formId: "asher_enrollment_agreement",
        label: "Enrollment Agreement",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_school_performance",
        label: "Performance Fact Sheet",
        include: function (json_data) { return json_data["campusState"] == "CA"; }
    },
    {
        formId: "asher_student_performance",
        label: "Completion and placement rates by program",
        include: function (json_data) { return json_data["campusState"] == "NV"; }
    },
    {
        formId: "asher_school_performance_texas",
        label: "School Performance",
        include: function (json_data) { return json_data["campusState"] == "TX"; }
    },
    {
        formId: "asher_record_previous_education",
        label: " CSC-010 Record of Previous Education",
        include: function (json_data) { return json_data["campusState"] == "TX"; }
    },
    {
        formId: "tour_receipt",
        label: "Tour Receipt",
        include: function (json_data) { return json_data["campusState"] == "TX"; }
    },
    {
        formId: "scholarship",
        label: "Scholarship",
        include: function (json_data) { return json_data["scholarship"] && json_data["scholarship"] != "0"; }
    },
    {
        formId: "asher_book_computer_opt_out",
        label: "Book Opt-Out Form",
        include: function (json_data) { return json_data["includeBookFees"] != "Include"; }
    },
    {
        formId: "asher_book_disclosure",
        label: "Book Disclosure",
        include: function (json_data) { return json_data["includeBookFees"] === "Include"; }
    },
    {
        formId: "w_9s",
        label: "W-9 Tax form",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_pharmacy_technician",
        label: "Pharmacy Technician License Information",
        include: function (json_data) { return ["X-FER-PT2020", "PT", "AAS-PT", "OLD-PT", "X-FER-PT"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Medical Records Specialist Certification",
        include: function (json_data) { return ["MRS", "X-FER-MRS"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Medical Coding and Billing Certification",
        include: function (json_data) { return ["MBC", "AAS-MBC", "X-FER-MBC", "X-FER-AAS-MBC"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Health Information Certification",
        include: function (json_data) { return ["HIS", "AAS-HI", "X-FER-HIS", "X-FER-AAS-HI"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_test_pass_assurance",
        label: "Test pass assurance",
        include: function (json_data) { return !["MRS", "X-FER-MRS", "MBC", "AAS-MBC", "X-FER-MBC", "X-FER-AAS-MBC", "HIS", "AAS-HI", "X-FER-HIS", "X-FER-AAS-HI", "X-FER-PT2020", "PT", "AAS-PT", "OLD-PT", "X-FER-PT"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_attendance_contract",
        label: "Attendance Contract",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_consent_release_information",
        label: "Consent To Release Information",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_electronic_notification_authorization",
        label: "Electronic Authorization",
        include: function (json_data) { return true; }
    },
    {
        formId: "dress_code",
        label: "Dress Code",
        include: function (json_data) { return true; }
    },
    {
        formId: "statistics",
        label: "Student Statistics",
        include: function (json_data) { return true; }
    },
    {
        formId: "diploma_request",
        label: "Diploma Request",
        include: function (json_data) { return json_data["includeHSDiploma"] == "Yes"; }
    },
    {
        formId: "ferpa_waiver",
        label: "Ferpa WAIVER",
        include: function (json_data) { return json_data["includeFERPA"] == "Yes"; }
    },
    {
        formId: "asher_student_referrals",
        label: "Student Referrals",
        include: function (json_data) { return true; }
    }
];
exports.ENROLLMENT_TRANSFER = [
    {
        formId: "program_change",
        label: "Program Change Addendum",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_enrollment_agreement_transfer",
        label: "Enrollment Agreeement Transfer",
        include: function (json_data) { return true; }
    },
    {
        formId: "asher_school_performance",
        label: "Performance Fact Sheet",
        include: function (json_data) { return json_data["campusState"] == "CA"; }
    },
    {
        formId: "asher_student_performance",
        label: "Completion and placement rates by program",
        include: function (json_data) { return json_data["campusState"] == "NV"; }
    },
    {
        formId: "asher_school_performance_texas",
        label: "School Performance",
        include: function (json_data) { return json_data["campusState"] == "TX"; }
    },
    {
        formId: "asher_book_computer_opt_out",
        label: "Book form",
        include: function (json_data) { return json_data["includeBookFees"] != "Include"; }
    },
    {
        formId: "asher_book_disclosure",
        label: "Book Disclosure",
        include: function (json_data) { return json_data["includeBookFees"] === "Include"; }
    },
    {
        formId: "scholarship",
        label: "Scholarship",
        include: function (json_data) { return json_data["scholarship"] && json_data["scholarship"] != "0"; }
    },
    ,
    {
        formId: "asher_pharmacy_technician",
        label: "Pharmacy Technician License Information",
        include: function (json_data) { return ["X-FER-PT2020", "PT", "AAS-PT", "OLD-PT", "X-FER-AAS-PT", "X-FER-PT"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Medical Records Specialist Certification",
        include: function (json_data) { return ["MRS", "X-FER-MRS"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Medical Coding and Billing Certification",
        include: function (json_data) { return ["MBC", "AAS-MBC", "X-FER-MBC", "X-FER-AAS-MBC"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_college_certification",
        label: "Health Information Certification",
        include: function (json_data) { return ["HIS", "AAS-HI", "X-FER-HIS", "X-FER-AAS-HI"].includes(json_data["programNumber"]); }
    },
    {
        formId: "asher_test_pass_assurance",
        label: "Test pass assurance",
        include: function (json_data) { return !["X-FER-PT2020", "PT", "AAS-PT", "OLD-PT", "X-FER-AAS-PT", "X-FER-PT", "MRS", "X-FER-MRS", "MBC", "AAS-MBC", "X-FER-MBC", "X-FER-AAS-MBC", "HIS", "AAS-HI", "X-FER-HIS", "X-FER-AAS-HI"].includes(json_data["programNumber"]); }
    },
    {
        formId: "accounting_upgrade",
        label: "Accounting upgrade downgrade",
        include: function (json_data) { return false; }
    }
];
//# sourceMappingURL=data:application/json;base64,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